import _state from './state'
import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.RESET_MODULE_STATE](state) {
    const initial = _state()
    Object.keys(initial).forEach(key => {
      state[key] = initial[key]
    })
  },
  [types.SET_DAYS](state, days) {
    state.retrospectiveDay = days
    storage.session.setItem(types.SESSION_DAYS, days)
  },
  [types.SET_STATUS](state, status) {
    state.status = status
    storage.session.setItem(types.SESSION_STATUS, status)
  },
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.SESSION_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.SESSION_PAGE_SIZE, pageSize)
  },
  [types.SET_REVIEW_REQUEST_STATISTICS](state, reviewRequestStatistics) {
    state.reviewRequestStatistics = reviewRequestStatistics
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/review-requests/mutations.js